import React from "react";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import tree from "assets/icons/tree_2.png";
import stylesB from "./TaskItem.module.scss";
import stylesW from "./TaskItemW.module.scss";
import userInfo from "utils/userInfo";
import moment from 'moment';

function TaskItem({ task, isSubtasks }) {
  const user = userInfo();
  const [styles, setThem] = useState(stylesB);
  const navigate = useNavigate();
  const handleClick = (id) => {
    // Ensure that the navigation happens only on a button click
    if (typeof id !== "undefined") {
      navigate(`/task/`, { state: { usedId: id } });
    }
  };
  useEffect(() => {
    if (user?.them) {
      setThem(stylesW);
    } else {
      setThem(stylesB);
    }
  }, []);
  const handleClickSub = (id) => {
    // Ensure that the navigation happens only on a button click
    if (typeof id !== "undefined") {
      navigate(`/subtask/`, { state: { usedId: id } });
    }
  };
  const formatDate = (dateString) => { 
    const date = moment(dateString, 'DD.MM.YYYY HH:mm');
    const today = moment();
  
    if (date.isSame(today, 'day')) {
      return date.format('Последний день выполнения');
     }
     else if (date.isBefore(today, 'day')) {
      return date.format('Просрочен от DD MMMM YYYY');
    }
    else if(date.isSame(today, 'year')){
      return date.format('Крайний срок до DD MMMM')
     } 
    else {
      return date.format('Крайний срок до DD MMMM YYYY');
    }
};
  const maxLength = 32;
  return (
    <div className={styles.wrapper}>
      <div className={styles.task_wrapper_flex}>
        <div
          className={styles.task__wrapper}
          style={
            task.is_critical
              ? { background: "rgb(239 3 3 / 22%)", borderRadius: "11px" }
              : {}
          }
        >
          <div className={styles.task__line}></div>

          <div className={styles.task_header}>
            <div className={styles.task_column}>
              <p
                className={styles.task__link}
                onClick={() => {
                  isSubtasks ? handleClickSub(task.id) : handleClick(task.id);
                }}
              >
                {/* {isSubtasks ? task.subtask_name : task.task_name} */}
                {isSubtasks
                  ? task.subtask_name.length > maxLength
                    ? task.subtask_name.substring(0, maxLength) + "..."
                    : task.subtask_name
                  : task.task_name.length > maxLength
                    ? task.task_name.substring(0, maxLength) + "..."
                    : task.task_name}
              </p>
              <span
                onClick={() => {
                  isSubtasks ? handleClickSub(task.id) : handleClick(task.id);
                }}
                className={styles.task__user}
              >
                {task &&
                  task.members_subtask &&
                  task.members_subtask[0]?.member &&
                  `${task.members_subtask[0].member.first_name} ${task.members_subtask[0].member.surname} `}
                {task &&
                  task.members &&
                  task.members[0]?.member &&
                  `${task.members[0].member.first_name} ${task.members[0].member.surname}`}
              </span>
            </div>
            <img
              title="Дерево задачи"
              className={styles.size}
              style={{filter:"invert(0.6)"}}
              src={tree}
              onClick={() => {
                navigate(`/task-tree/`, {
                  state: { isSubtasks: isSubtasks, usedId: task.id },
                });
              }}
              alt=""
            />
          </div>

          <div>
            <p
              className={styles.task__term3}
              onClick={() => {
                isSubtasks ? handleClickSub(task.id) : handleClick(task.id);
              }}
            >
              {task.status}{" "}
              {task.status === "Завершена" ? (
                <span> {task.edit_status_date}</span>
              ) : (
                ""
              )}{" "}
            </p>
          </div>

          <div className={styles.dates}>
            <div>
              {task.deadline_date === null ? (
                <p
                  className={styles.task__term2}
                  onClick={() => {
                    isSubtasks ? handleClickSub(task.id) : handleClick(task.id);
                  }}
                >
                  {/* Срок до: Бессрочная{" "} */}
                </p>
              ) : (
                <p
                  className={styles.task__term2}
                  onClick={() => {
                    isSubtasks ? handleClickSub(task.id) : handleClick(task.id);
                  }}
                >
                  {" "}
                  {`${formatDate(task.deadline_date)}`}{" "}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TaskItem;
